import { Map } from 'immutable'
import { createSelector } from 'reselect'

export const appointmentDashboardState = (state: Map<string, any>) => state?.get('appointmentDashboard')

export const appointmentDashboardBookingStatus = createSelector(
  appointmentDashboardState,
  (state) => state?.get('bookingStatus') || '',
)

export const getAppointments = createSelector(appointmentDashboardState, (state) => state?.get('appointments'))

export const getAppointmentDataLoaded = createSelector(
  appointmentDashboardState,
  (state) => state?.get('appointmentDataLoaded') ?? false,
)

export const getNonCanceledAppointments = createSelector(getAppointments, (appointments) =>
  appointments?.filter((appointment: Map<string, any>) => appointment.get('appointmentStatus') !== 'canceled'),
)

export const getAppointmentCount = createSelector(getAppointments, (appointments) => appointments?.size ?? 0)
